<div class="form-check form-check-inline">
  <input
    type="checkbox"
    class="form-check-input"
    [id]="building.building.buildingNumber"
    [checked]="selectedBuildingIds.includes(building.building.buildingNumber)"
    (change)="toggleCheckbox(building.building.buildingNumber)"
  />
  <label class="form-check-label" [for]="building.building.buildingNumber">{{
    formatAddress(building)
  }}</label>
</div>
